'use strict';

module.exports = {
    DATADOG_ENABLED: 'datadog-enabled'
};